import { render } from "./HotSales.vue?vue&type=template&id=1df97fb6&scoped=true"
import script from "./HotSales.vue?vue&type=script&lang=js"
export * from "./HotSales.vue?vue&type=script&lang=js"

import "./HotSales.vue?vue&type=style&index=0&id=1df97fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df97fb6"]])

export default __exports__